import React from 'react';
import BaseSizeSensitiveComponent from "../components/BaseSizeSensitiveComponent";


class Privacy extends BaseSizeSensitiveComponent {
    render() {

        var introSectionStyle = {
            marginTop: 15,
            marginBottom: 15,
            marginLeft: 30,
            marginRight: 30,
            color: "#e0e0e0"
        }

        return (
            <section style={introSectionStyle}>
                <p><b>Privacy Policy:</b></p>
                <p/>
                <p><strong>Mobile and Desktop Applications: </strong> In our apps we collect NO information. Therefore by definition we cannot share it with anyone, sell it to anyone, or use it to harass you in any way. Nor would we want to.</p>
                <p><strong>Mobile phone numbers and SMS: </strong> We rarely send any SMS (Text) messages and then only
                    to people who have opted in. Users may reply to any of our messages with the text "STOP" to opt out
                    of receiving any future messages. We do our absolute best to honor any opt-out's we receive. Any
                    personal information, including mobile numbers provided to us will never be shared with anyone for
                    any purpose.<br/>
                    <input type="checkbox" id="smsoptout" name="smsoptout" value="smsoptout"/>  Click here to opt out of SMS messaging.
                </p>
            </section>
        );
    }
}

export default Privacy


// WEBPACK FOOTER //
// src/Privacy/Privacy.js